import { Center } from '../../lib/types/models/center/center'
import { CenterRequestInput } from '../../lib/types/models/center/center-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateCenter({ id, ...rest }: UpdateInput<CenterRequestInput>) {
  return restApiClient
    .url(constructApiUrl(API.centers.update.url, { id }))
    .patch<Center, Partial<CenterRequestInput>>(rest)
}

export const lockCenter = (id: number) => {
  return restApiClient.url(constructApiUrl(API.centers.lock.url, { id })).post<Center>()
}

export const unlockCenter = (id: number) => {
  return restApiClient.url(constructApiUrl(API.centers.unlock.url, { id })).post<Center>()
}
